export enum StartupStatus {
  Building = "Building",
  Zombie = "Zombie",
  // Financial situation:
  Bootstrapping = "Bootstrapping",
  Raising = "Raising",
  // Exit processes:
  Exiting = "Exiting",
  ShuttingDown = "ShuttingDown",
  // Exit completed:
  ExitAcquired = "ExitAcquired",
  ExitDissolved = "ExitDissolved",
  //
  Unknown = "Unknown",
}
